import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import * as auth from "../store/ducks/auth.duck";
import { connect } from "react-redux";
import BetterSelect from "./BetterSelect";
import { listaTipoFornecedor, textoExclusao } from "../utils/Utils";
import AssociadoAutoComplete from "./AssociadoAutoComplete";
import ModalCancelarContrato from "./ModalCancelarContrato";
import ModalAlterarStatus from "./ModalAlterarStatus";
import ModalAlteracaoMassa from "./ModalAlteracaoMassa";

class BetterDataTable extends Component {
    constructor() {
        super();

        this.state = {
            data: [],
            rows: 10,
            totalRecords: 0,
            first: 0,
            last: 0,
            loading: false,
            globalFilter: null,
            tipo_fornecedor: null,
            associado: null,
            selected_items: [],
            modal_cancelar: false,
            modal_alterar_status: false,
            modal_alteracao_massa: false,
            submitted: false,
        };

        this.onPage = this.onPage.bind(this);
    }

    componentDidUpdate() {
        if (this.props.refresh) {
            this.props.setRefresh(false);
            this.refreshTable();
        }
    }

    componentDidMount() {
        const tipoFornecedorSalvo = sessionStorage.getItem("tipo_fornecedor");
        const filter = this.props.globalFilter ?? this.state.globalFilter;
        this.setState(
            {
                globalFilter: filter,
                tipo_fornecedor: tipoFornecedorSalvo || this.state.tipo_fornecedor,
            },
            () => {
                this.onPage(this.state);
            }
        );
    }

    doGlobalFiltering(value) {
        this.setState({ globalFilter: value });

        setTimeout(() => {
            let event = { ...this.state, globalFilter: value };
            this.onPage(event);
        }, 350);
    }

    refreshTable() {
        this.onPage(this.state);
    }

    onPage = (event) => {
        if (event.data) {
            event.data = null;
        }

        this.setState({
            ...this.state,
            rows: event.rows,
            loading: true,
        });

        this.props
            .fetchEvent({
                ...event,
                ...this.state,
                rows: event.rows,
                tipo_fornecedor: this.state.tipo_fornecedor,
                id_associado: this.state.associado?.id,
            })
            .then((res) => {
                let data = [];
                let totalRecords = 0;
                let first = 0;
                let last = 0;

                if (res?.data?.paginacao) {
                    data = res.data.paginacao.data ?? [];
                    totalRecords = res.data.paginacao.total ?? 0;
                    first = (res.data.paginacao.from ?? 1) - 1;
                    last = (res.data.paginacao.to ?? 0) - 1;
                } else {
                    data = res.data.data.data ?? [];
                    totalRecords = res.data.data.total ?? 0;
                    first = (res.data.data.from ?? 1) - 1;
                    last = (res.data.data.to ?? 0) - 1;
                }

                this.setState({
                    ...this.state,
                    data,
                    totalRecords,
                    first,
                    last,
                    loading: false,
                });
            })
            .catch(() => this.setState({ loading: false }));
    };

    handleDelete = (id) => {
        Swal.fire({
            title: "Atenção!",
            text: "Tem certeza que deseja remover esse registro?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Não",
            confirmButtonText: "Sim",
        }).then((result) => {
            if (result.value) {
                if (this.props.deleteHandler) {
                    this.setState({ loading: true });

                    this.props
                        .deleteHandler(id)
                        .then(() => {
                            this.refreshTable();

                            Swal.fire("Tudo certo!", "Registro removido com sucesso!", "success");
                            this.setState({ loading: false });
                        })
                        .catch((err) => {
                            if (this.props.useErrorsOnDestroy) {
                                Swal.fire("Ops", err?.response?.data?.errors ? err?.response?.data?.errors.join(" .") : "Houve um problema ao remover o registro. Entre em contato com o suporte.", "error");
                            } else {
                                Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Houve um problema ao remover o registro. Entre em contato com o suporte.", "error");
                            }

                            this.setState({ loading: false });
                        });
                } else {
                    alert("Nenhum método de remoção definido.");
                }
            }
        });
    };

    refresh = () => {
        this.refreshTable();
    };

    columnOpcoesCrud = (rowData) => {
        let id = this.props.idRow ? rowData[this.props.idRow] : rowData["id"];
        let tipo = this.props.tipo ? rowData[this.props.tipo] : null;

        if (this.props.crudUrl) {
            let editUrl = tipo ? `${this.props.crudUrl}/edit/${id}/${tipo}` : `${this.props.crudUrl}/edit/${id}`;

            if (this.props.editUrlCustomizer) {
                editUrl = this.props.editUrlCustomizer(editUrl, rowData);
            }

            return (
                <div style={{ textAlign: "center" }}>
                    {this.props.moreOptions ? this.props.moreOptions(rowData, () => this.refresh()) : null}

                    {!this.props.noEdit ? (
                        <Link to={editUrl} className="btn btn-success btn-table-action">
                            <i className="fa fa-edit"></i>
                        </Link>
                    ) : null}

                    {!this.props.noShow ? (
                        <Link to={tipo ? `${this.props.crudUrl}/show/${id}/${tipo}` : `${this.props.crudUrl}/show/${id}`} className="btn btn-primary btn-table-action">
                            <i className="fas fa-eye"></i>
                        </Link>
                    ) : null}

                    {!this.props.noDelete ? (
                        <button type="button" onClick={() => this.handleDelete(id)} className="btn btn-danger btn-table-action">
                            <i className="fas fa-trash-alt"></i>
                        </button>
                    ) : null}
                </div>
            );
        } else {
            return null;
        }
    };

    export() {
        this.dt.exportCSV();
    }

    cancelarContratos = () => {
        if (this.state.selected_items.length === 0) {
            return Swal.fire("Atenção!", "Selecione pelo menos um contrato para inativar.", "warning");
        }

        this.setState({ modal_cancelar: true });
    };

    alterarStatus = () => {
        if (this.state.selected_items.length === 0) {
            return Swal.fire("Atenção!", "Selecione pelo menos um contrato para alterar o status.", "warning");
        }

        this.setState({ modal_alterar_status: true });
    };

    alteracaoMassa = () => {
        this.setState({ modal_alteracao_massa: true });
    };

    gerarLinkFaturas = () => {
        if (this.state.selected_items.length < 2) {
            return Swal.fire("Atenção!", "Selecione pelo menos duas faturas para agrupar.", "warning");
        }

        if (this.state.selected_items.find((obj) => obj.fat_metodo_pagamento !== "Boleto")) {
            return Swal.fire("Atenção!", "Selecione somente faturas do tipo boleto.", "warning");
        }

        this.setState({ submitted: true });

        this.props
            .gerarLinkFaturas({ array_faturas: this.state.selected_items.map((obj) => obj.id) })
            .then((res) => {
                if (!res.data?.errors) {
                    this.setState({ selected_items: [] });

                    Swal.fire("Sucesso!", "Link gerado com sucesso!<br><br><a href='" + res.data.url + "' target='_blank'>Link para download</a>", "success");
                } else {
                    Swal.fire("Ops!", res.data?.errors?.[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                }
            })
            .catch((err) => {
                Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
            })
            .finally(() => this.setState({ submitted: false }));
    };

    agruparSelecionados = () => {
        if (this.state.selected_items.length < 2) {
            return Swal.fire("Atenção!", "Selecione pelo menos duas faturas para agrupar.", "warning");
        }

        this.setState({ submitted: true });

        Swal.fire({ ...textoExclusao, text: `Deseja realmente agrupar as faturas selecionadas?` }).then((result) => {
            if (result.value) {
                this.props
                    .agruparSelecionados({ array_faturas: this.state.selected_items.map((obj) => obj.id) })
                    .then((res) => {
                        if (!res.data?.errors) {
                            this.refreshTable();

                            this.setState({ selected_items: [] });

                            Swal.fire("Sucesso!", "Faturas agrupadas com sucesso!", "success");
                        } else {
                            Swal.fire("Ops!", res.data?.errors?.[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                        }
                    })
                    .catch((err) => {
                        Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                    })
                    .finally(() => this.setState({ submitted: false }));
            }
        });
    };

    cancelarFaturasSelecionadas = () => {
        if (this.state.selected_items.length < 1) {
            return Swal.fire("Atenção!", "Selecione pelo menos uma fatura para agrupar.", "warning");
        }

        this.setState({ submitted: true });

        Swal.fire({ ...textoExclusao, text: `Deseja realmente cancelar as faturas selecionadas?` }).then((result) => {
            if (result.value) {
                this.props
                    .cancelarFaturasSelecionadas({ array_faturas: this.state.selected_items.map((obj) => obj.id) })
                    .then((res) => {
                        if (!res.data?.errors) {
                            this.refreshTable();

                            this.setState({ selected_items: [] });

                            Swal.fire("Sucesso!", "Faturas canceladas com sucesso!", "success");
                        } else {
                            Swal.fire("Ops!", res.data?.errors?.[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                        }
                    })
                    .catch((err) => {
                        Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                    })
                    .finally(() => this.setState({ submitted: false }));
            }
        });
    };

    // ========= NOVO: Selecionar todos filtrados (endpoint sem paginação) =========
    selecionarTodosFiltrados = () => {
        if (!this.props.fetchAllEvent) return;

        this.setState({ submitted: true });

        this.props
            .fetchAllEvent({
                ...this.state,
                tipo_fornecedor: this.state.tipo_fornecedor,
                id_associado: this.state.associado?.id,
            })
            .then((res) => {
                // Tenta se adaptar a diferentes formatos de resposta
                const all =
                    res?.data?.data && Array.isArray(res.data.data)
                        ? res.data.data
                        : Array.isArray(res?.data)
                        ? res.data
                        : [];

                this.setState({ selected_items: all });
            })
            .catch((err) => {
                Swal.fire("Ops!", err?.response?.data?.errors?.[0] ?? "Não foi possível carregar todos os registros filtrados.", "error");
            })
            .finally(() => this.setState({ submitted: false }));
    };
    // ============================================================================

    render() {
        const header = (
            <div className="row d-flex align-items-center">
                <div className="col-xl col-12">
                    <div className="row" style={{ gap: "10px" }}>
                        {this.props.tipo_fornecedor && (
                            <div className="col-md-4">
                                <BetterSelect
                                    size={"small"}
                                    label="Tipo de prestador"
                                    labelWidth={115}
                                    style={{ marginTop: 8, marginBottom: 8 }}
                                    onChange={(e) => {
                                        sessionStorage.setItem("tipo_fornecedor", e.target.value);
                                        this.setState({ tipo_fornecedor: e.target.value }, () => this.onPage(this.state));
                                    }}
                                    value={this.state.tipo_fornecedor}
                                    blankOption
                                >
                                    {listaTipoFornecedor.map((obj, i) => (
                                        <option key={i} value={obj}>
                                            {obj}
                                        </option>
                                    ))}
                                </BetterSelect>
                            </div>
                        )}

                        {this.props.associado && (
                            <div className="col-md-4">
                                <AssociadoAutoComplete value={this.state.associado} setValue={(e) => this.setState({ associado: e }, () => this.onPage(this.state))} />
                            </div>
                        )}

                        {this.props.selectionMode && this.props.fetchAllEvent && (
                            <button type="button" className="btn btn-warning btn-bold" onClick={this.selecionarTodosFiltrados}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-check-square"}`}></i>
                                Selecionar todos contratos filtrados
                            </button>
                        )}

                        {this.props.cancelarSelecionados && (
                            <button type="button" className="btn btn-danger btn-bold" onClick={() => this.cancelarContratos()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-window-close"}`}></i>
                                Inativar contrato(s)
                            </button>
                        )}

                        {this.props.alterarStatus && (
                            <button type="button" className="btn btn-info btn-bold" onClick={() => this.alterarStatus()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-exchange-alt"}`}></i>
                                Alterar status
                            </button>
                        )}

                        {this.props.alteracaoMassa && (
                            <button type="button" className="btn btn-warning btn-bold" onClick={() => this.alteracaoMassa()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-edit"}`}></i>
                                Alteração em Massa
                            </button>
                        )}

                        {this.props.cancelarFaturasSelecionadas && (
                            <button type="button" className="btn btn-danger btn-bold" onClick={() => this.cancelarFaturasSelecionadas()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-window-close"}`}></i>
                                Cancelar faturas
                            </button>
                        )}

                        {this.props.agruparSelecionados && (
                            <button type="button" className="btn btn-info btn-bold" onClick={() => this.agruparSelecionados()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-layer-group"}`}></i>
                                Agrupar faturas
                            </button>
                        )}

                        {this.props.gerarLinkFaturas && (
                            <button type="button" className="btn btn-primary btn-bold" onClick={() => this.gerarLinkFaturas()}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-link"}`}></i>
                                Gerar link de faturas selecionadas
                            </button>
                        )}
                    </div>
                </div>

                {!this.props.noSearch && (
                    <div className="table-header-search" style={{ paddingRight: 12 }}>
                        <InputText
                            className="tableHeaderItem"
                            style={{ marginRight: "5px" }}
                            type="search"
                            value={(this.props.globalFilter ?? this.state.globalFilter) || ""}
                            onInput={(e) => {
                                if (this.props.setGlobalFilter) {
                                    this.props.setGlobalFilter(e.target.value);
                                    this.doGlobalFiltering(e.target.value);
                                } else {
                                    this.setState({ globalFilter: e.target.value });
                                    this.doGlobalFiltering(e.target.value);
                                }
                            }}
                            placeholder="Pesquise..."
                            size="30"
                        />
                        <Button className="tableHeaderItem" icon={!this.state.loading ? "fas fa-sync" : "fas fa-sync fa-spin"} disabled={this.state.loading ? "disabled" : ""} onClick={() => this.refreshTable()} />
                    </div>
                )}
            </div>
        );

        return (
            <>
                <DataTable
                    ref={(el) => (this.dt = el)}
                    selectionMode={null}
                    selection={this.state.selected_items}
                    onSelectionChange={(e) => this.setState({ selected_items: e.value })}
                    dataKey="id"
                    value={this.state.data}
                    paginator={true}
                    rows={this.state.rows}
                    rowsPerPageOptions={[10, 25, 50]}
                    csvSeparator={";"}
                    first={this.state.first}
                    last={this.state.last}
                    header={this.props.noHeader ? null : header}
                    globalFilter={this.state.globalFilter}
                    responsive={!this.props.scrollable}
                    scrollable={this.props.scrollable}
                    totalRecords={this.state.totalRecords}
                    lazy={true}
                    onPage={this.onPage}
                    loading={this.state.loading}
                    loadingIcon={`fas fa-sync fa-spin`}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords} registros"
                    emptyMessage="Nenhum registro encontrado!"
                >
                    {this.props.selectionMode && <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />}

                    {this.props.children}

                    {this.props.crudButtons ? <Column header="Opções" body={this.columnOpcoesCrud} style={{ width: this.props.crudButtonsWidth ?? "190px" }} /> : null}
                </DataTable>

                <ModalCancelarContrato
                    open={this.state.modal_cancelar}
                    setOpen={(e) => this.setState({ modal_cancelar: e })}
                    array_id_contratos={this.state.selected_items.map((obj) => obj.id)}
                    after={() => {
                        this.setState({ selected_items: [] });
                        this.refreshTable();
                    }}
                />

                <ModalAlterarStatus
                    open={this.state.modal_alterar_status}
                    setOpen={(e) => this.setState({ modal_alterar_status: e })}
                    array_contratos={this.state.selected_items}
                    after={() => {
                        this.setState({ selected_items: [] });
                        this.refreshTable();
                    }}
                />

                <ModalAlteracaoMassa
                    open={this.state.modal_alteracao_massa}
                    setOpen={(e) => this.setState({ modal_alteracao_massa: e })}
                    after={() => {
                        this.setState({ selected_items: [] });
                        this.refreshTable();
                    }}
                />
            </>
        );
    }
}

const mapStateToProps = ({ auth: { user } }) => {
    return {
        user: user,
    };
};

export default connect(mapStateToProps, auth.actions)(BetterDataTable);
